import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import '../scss/style.scss';
import './gtm.js';
import './hero-event-timer.js';
import './fmf-2027-agenda.js';
import './fmf-2027-conference-agenda.js';
import './fmf-2027-voices.js';
import './country-pavilion-countries.js';
import './country-pavilion-modal.js';



(function () {
  'use strict';

  // =====================
  // 0a. Homepage preloader — hide once page is ready + min show time
  // =====================


  (function initPreloader() {
    var preloader = document.getElementById('fmfPreloader');

    if (sessionStorage.getItem('fmf_loaded')) {
      if (preloader && preloader.parentNode) {
        preloader.parentNode.removeChild(preloader);
      }
      document.body.classList.add('page-loaded');
      return;
    }

    if (!preloader) {
      document.body.classList.add('page-loaded');
      return;
    }




    // ── Ripple canvas setup ──
    var canvas = document.getElementById('fmfRippleCanvas');
    var ctx = canvas ? canvas.getContext('2d') : null;
    var rippleRAF = null;
    var rippleStart = null;

    function resizeCanvas() {
      if (!canvas) return;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }


    // ── Hide logic ──
    var MIN_DISPLAY_MS = 500;
    var startedAt = Date.now();
    var hidden = false;

    function hide() {
      if (hidden) return;
      hidden = true;
      sessionStorage.setItem('fmf_loaded', '1');

      var elapsed = Date.now() - startedAt;
      var wait = Math.max(0, MIN_DISPLAY_MS - elapsed);

      setTimeout(function () {
        preloader.classList.add('is-hidden');
        document.body.classList.add('page-loaded');

        setTimeout(function () {
          document.querySelectorAll('.animate-on-scroll').forEach(function (el) {
            el.classList.add('is-visible');
          });
        }, 400);











        setTimeout(function () {
          if (preloader && preloader.parentNode) {
            preloader.parentNode.removeChild(preloader);
          }
        }, 5500);
      }, wait);
    }

    if (document.readyState === 'complete') {
      hide();
    } else {
      window.addEventListener('load', hide, { once: true });
      setTimeout(hide, 2000); // safety net
    }
  })();
  // =====================
  // 0. Mobile nav toggle (hamburger)
  // =====================
  (function initMobileNav() {
    var toggle = document.getElementById('navToggle');
    var links = document.getElementById('navLinks');
    if (!toggle || !links) return;

    function closeNav() {
      links.classList.remove('is-open');
      document.body.classList.remove('nav-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      var isOpen = links.classList.toggle('is-open');
      document.body.classList.toggle('nav-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    links.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeNav);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 991) closeNav();
    });
  })();

  // =====================
  // 0b. Mega Menu overlay & transitions
  // =====================
  (function initMegaMenu() {
    const aboutDropdown = document.querySelector('.dropdown-hover');
    const overlay = document.querySelector('.mega-menu-overlay');
    if (!aboutDropdown || !overlay) return;

    aboutDropdown.addEventListener('mouseenter', function () {
      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      document.body.classList.add('mega-menu-open');
    });

    aboutDropdown.addEventListener('mouseleave', function () {
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      document.body.classList.remove('mega-menu-open');
    });

    // Handle closing when menu items inside are clicked
    const menuLinks = aboutDropdown.querySelectorAll('.mega-menu a');
    menuLinks.forEach(link => {
      link.addEventListener('click', () => {
        overlay.style.opacity = '0';
        overlay.style.visibility = 'hidden';
        document.body.classList.remove('mega-menu-open');
      });
    });
  })();

  // =====================
  // 1. Intersection Observer for scroll animations
  // =====================
  const scrollElements = document.querySelectorAll('.animate-on-scroll');
  const scrollObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });

  scrollElements.forEach(function (el) {
    scrollObserver.observe(el);
  });

  // =====================
  // 2. Counter animation for stats numbers
  // =====================
  var statsAnimated = false;
  var statsSection = document.querySelector('.stats-section');

  function animateCounters() {
    if (statsAnimated) return;
    statsAnimated = true;

    var counters = document.querySelectorAll('.stat-number[data-target]');
    counters.forEach(function (counter) {
      var target = parseInt(counter.getAttribute('data-target'));
      var prefix = counter.getAttribute('data-prefix') || '';
      var suffix = counter.getAttribute('data-suffix') || '';
      var mainSuffix = suffix; // was .replace('+', '')
      var duration = 2000;
      var start = 0;
      var startTime = null;

      function easeOutQuart(t) {
        return 1 - Math.pow(1 - t, 4);
      }

      function update(timestamp) {
        if (!startTime) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easeOutQuart(progress);
        var current = Math.floor(easedProgress * target);
        counter.innerHTML = prefix + current + mainSuffix; //was  + '<span class="stat-suffix">+</span>';
        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          counter.innerHTML = prefix + target + mainSuffix; //was  + '<span class="stat-suffix">+</span>';
        }
      }

      requestAnimationFrame(update);
    });
  }

  var statsObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCounters();
      }
    });
  }, { threshold: 0.3 });

  if (statsSection) {
    statsObserver.observe(statsSection);
  }

  // =====================
  // 3. Quote rotation in dialogue section
  // =====================
  var quoteItems = document.querySelectorAll('.quote-text-item');
  var currentQuote = 0;

  if (quoteItems.length > 1) {
    setInterval(function () {
      quoteItems[currentQuote].classList.remove('active');
      currentQuote = (currentQuote + 1) % quoteItems.length;
      quoteItems[currentQuote].classList.add('active');
    }, 4000);
  }

  // =====================
  // 4. Ticker close button functionality
  // =====================
  var tickerClose = document.getElementById('tickerClose');
  var tickerBar = document.getElementById('tickerBar');

  if (tickerClose && tickerBar) {
    tickerClose.addEventListener('click', function () {
      tickerBar.classList.add('hidden');
      setTimeout(function () {
        tickerBar.style.display = 'none';
      }, 400);
    });
  }






  // 4b. CTA arrow animation on hover in/out changes*
  // ================================
  document.querySelectorAll('.cta-btn').forEach(function (btn) {
    var arrow = btn.querySelector('.cta-arrow');
    if (!arrow) return;

    btn.addEventListener('mouseenter', function () {
      arrow.style.filter = 'brightness(0) invert(1)';
      arrow.style.animation = 'none';
      arrow.offsetHeight;
      arrow.style.animation = 'arrowSlide 0.6s ease-in-out 1 forwards';
    });

    btn.addEventListener('mouseleave', function () {
      arrow.style.filter = '';
      arrow.style.animation = 'none';
      arrow.offsetHeight;
      arrow.style.animation = 'arrowSlide 0.2s ease-in-out 1 reverse forwards';
    });
  });

  // 4c. Nav Download Brochure — vertical drop/rise arrow animation (nav only)
  // ================================
  (function () {
    var navBtns = document.querySelectorAll('.nav-download-cta');

    navBtns.forEach(function (navBtn) {
      var icon = navBtn.querySelector('.download-icon');
      if (!icon) return;

      navBtn.addEventListener('mouseenter', function () {
        icon.style.filter = 'brightness(0) invert(1)';
        icon.style.animation = 'none';
        icon.offsetHeight;
        icon.style.animation = 'downloadArrowCycle 0.4s ease-out 1 forwards';
      });

      navBtn.addEventListener('mouseleave', function () {
        icon.style.filter = '';
        icon.style.animation = 'none';
        icon.offsetHeight;
        icon.style.animation = 'downloadArrowCycleOut 0.4s ease-out 1 forwards';
      });
    });
  })();
  //==============================================
  //==============================================

  // =====================
  // 5. Nav shadow on scroll
  // =====================
  var mainNav = document.getElementById('mainNav');
  var navToggle = mainNav ? mainNav.querySelector('.nav-toggle') : null;
  var navLinks = mainNav ? mainNav.querySelectorAll('.nav-links a') : [];

  function setNavMenu(open) {
    if (!mainNav || !navToggle) return;

    mainNav.classList.toggle('menu-open', open);
    document.body.classList.toggle('nav-menu-open', open);
    navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    navToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    var menuText = navToggle.querySelector('.menu-text');
    if (menuText) {
      menuText.textContent = open ? 'Close Menu' : 'Menu';
    }
  }

  if (navToggle) {
    navToggle.addEventListener('click', function () {
      setNavMenu(!mainNav.classList.contains('menu-open'));
    });

    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        setNavMenu(false);
      });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) {
        setNavMenu(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setNavMenu(false);
      }
    });
  }

  // =====================
  // 5b. Scroll-aware header hide/show (requestAnimationFrame-optimised) 
  // =====================
  (function initScrollAwareNav() {
    if (!mainNav) return;

    var lastScrollY = window.scrollY;
    var ticking = false;
    // Minimum scroll delta (px) before toggling — prevents jitter on tiny movements
    var SCROLL_THRESHOLD = 5;
    // The nav must be scrolled past this Y before it can hide (prevents hiding at page top)
    var HIDE_OFFSET = 80;

    function onScroll() {
      var currentScrollY = window.scrollY;

      // Allow temporary suppression of the header scroll logic during layout shifts
      if (window.pauseHeaderNavUntil && Date.now() < window.pauseHeaderNavUntil) {
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      // Always show the nav when near the top of the page
      if (currentScrollY <= HIDE_OFFSET) {
        mainNav.classList.remove('nav-hidden');
        mainNav.classList.remove('scrolled');
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      // Shadow when scrolled past top
      mainNav.classList.add('scrolled');

      var delta = currentScrollY - lastScrollY;

      // Scrolling down past threshold → hide
      if (delta > SCROLL_THRESHOLD) {
        // Don't hide if the mobile menu is open
        if (!mainNav.classList.contains('menu-open')) {
          mainNav.classList.add('nav-hidden');
        }
      }
      // Scrolling up past threshold → show
      else if (delta < -SCROLL_THRESHOLD) {
        mainNav.classList.remove('nav-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  })();

  // =====================
  // 6. Strategy timeline/arrows/dots + scroll sync
  // =====================
  var timelineYears = document.querySelectorAll('.timeline-year');
  var strategyCardsContainer = document.getElementById('strategyCards');
  var strategyCards = strategyCardsContainer ? strategyCardsContainer.querySelectorAll('.strategy-card') : [];
  var strategyProgressFill = document.getElementById('strategyProgressFill');
  var strategyPrev = document.getElementById('strategyPrev');
  var strategyNext = document.getElementById('strategyNext');
  var strategyDots = document.querySelectorAll('.strategy-dot');
  var timelineActive = document.getElementById('timelineActive');
  var currentStrategyIndex = 0;
  var programmaticStrategyIndex = null;
  var strategyScrollTimer = null;

  // Use getBoundingClientRect so the scroll offset is correct
  // regardless of the container's offsetParent. The old calculation
  // (card.offsetLeft - container.offsetLeft) broke on index 1 when
  // the two had different positioned ancestors.
  function scrollToStrategyCard(index) {
    if (!strategyCardsContainer || !strategyCards[index]) return;
    currentStrategyIndex = index;
    programmaticStrategyIndex = index;
    var card = strategyCards[index];
    var containerRect = strategyCardsContainer.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var delta = cardRect.left - containerRect.left;
    strategyCardsContainer.scrollTo({
      left: strategyCardsContainer.scrollLeft + delta,
      behavior: 'smooth'
    });
    updateStrategyTimeline(index);
    updateStrategyProgress(index);
    updateStrategyDots(index);
    updateStrategyArrows(index);
  }

  function updateStrategyTimeline(index) {
    timelineYears.forEach(function (y, i) {
      y.classList.toggle('active', i === index);
    });
    if (timelineActive && strategyCards.length > 0) {
      var segmentWidth = 100 / strategyCards.length;
      timelineActive.style.left = (index * segmentWidth) + '%';
      timelineActive.style.width = segmentWidth + '%';
    }
  }

  function updateStrategyProgress(index) {
    if (strategyProgressFill && strategyCards.length > 0) {
      var pct = ((index + 1) / strategyCards.length) * 100;
      strategyProgressFill.style.width = pct + '%';
    }
  }

  function updateStrategyDots(index) {
    if (!strategyDots || !strategyDots.length) return;
    strategyDots.forEach(function (d, i) {
      d.classList.toggle('active', i === index);
    });
  }

  function updateStrategyArrows(index) {
    if (!strategyPrev || !strategyNext || !strategyCards.length) return;

    var isFirst = index <= 0;
    var isLast = index >= strategyCards.length - 1;

    strategyPrev.classList.toggle('disabled', isFirst);
    strategyPrev.classList.toggle('active', !isFirst);
    strategyPrev.disabled = isFirst;
    strategyPrev.setAttribute('aria-disabled', isFirst ? 'true' : 'false');

    strategyNext.classList.toggle('disabled', isLast);
    strategyNext.classList.toggle('active', !isLast);
    strategyNext.disabled = isLast;
    strategyNext.setAttribute('aria-disabled', isLast ? 'true' : 'false');
  }

  function getStrategyIndexFromScroll() {
    if (!strategyCardsContainer || !strategyCards.length) return 0;

    var scrollLeft = strategyCardsContainer.scrollLeft;
    var maxScroll = strategyCardsContainer.scrollWidth - strategyCardsContainer.clientWidth;
    if (maxScroll > 0 && scrollLeft >= maxScroll - 1) {
      return strategyCards.length - 1;
    }

    var nearestIndex = 0;
    var nearestDistance = Infinity;
    strategyCards.forEach(function (card, index) {
      var distance = Math.abs(card.offsetLeft - scrollLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  timelineYears.forEach(function (year) {
    year.addEventListener('click', function () {
      var idx = parseInt(this.getAttribute('data-index'), 10);
      scrollToStrategyCard(idx);
    });
  });

  strategyDots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var idx = parseInt(this.getAttribute('data-index'), 10);
      scrollToStrategyCard(idx);
    });
  });

  if (strategyPrev) {
    strategyPrev.addEventListener('click', function () {
      if (currentStrategyIndex > 0) {
        scrollToStrategyCard(currentStrategyIndex - 1);
      }
    });
  }

  if (strategyNext) {
    strategyNext.addEventListener('click', function () {
      if (currentStrategyIndex < strategyCards.length - 1) {
        scrollToStrategyCard(currentStrategyIndex + 1);
      }
    });
  }

  // Sync timeline / progress / dots while the user scrolls the track
  if (strategyCardsContainer) {
    strategyCardsContainer.addEventListener('scroll', function () {
      var scrollLeft = strategyCardsContainer.scrollLeft;
      var maxScroll = strategyCardsContainer.scrollWidth - strategyCardsContainer.clientWidth;
      if (maxScroll > 0) {
        var ratio = scrollLeft / maxScroll;
        var idx = programmaticStrategyIndex !== null ? programmaticStrategyIndex : getStrategyIndexFromScroll();
        if (idx !== currentStrategyIndex) {
          currentStrategyIndex = idx;
          updateStrategyTimeline(idx);
          updateStrategyDots(idx);
          updateStrategyArrows(idx);
        }
        if (strategyProgressFill) {
          strategyProgressFill.style.width = (ratio * 100) + '%';
        }
        if (programmaticStrategyIndex !== null) {
          window.clearTimeout(strategyScrollTimer);
          strategyScrollTimer = window.setTimeout(function () {
            currentStrategyIndex = programmaticStrategyIndex;
            updateStrategyTimeline(currentStrategyIndex);
            updateStrategyProgress(currentStrategyIndex);
            updateStrategyDots(currentStrategyIndex);
            updateStrategyArrows(currentStrategyIndex);
            programmaticStrategyIndex = null;
          }, 120);
        }
      }
    }, { passive: true });
  }

  updateStrategyTimeline(currentStrategyIndex);
  updateStrategyProgress(currentStrategyIndex);
  updateStrategyDots(currentStrategyIndex);
  updateStrategyArrows(currentStrategyIndex);

  // =====================
  // 7. Ecosystem node click to update info panel
  // =====================
  var ecosystemData = {
    governments: {
      title: 'Governments',
      items: [
        'Policymakers shaping national mineral strategy',
        'Driving cross-border policy alignment',
        'Engaging industry and investors to strengthen supply resilience'
      ]
    },
    institutions: {
      title: 'Development Institutions',
      items: [
        'Providing technical assistance and capacity building',
        'Financing sustainable mining projects and infrastructure',
        'Supporting research and data to inform mineral policy'
      ]
    },
    investors: {
      title: 'Investors',
      items: [
        'Channeling capital into sustainable mineral ventures',
        'Identifying high-potential investment opportunities',
        'Driving ESG standards and responsible investment'
      ]
    },
    industry: {
      title: 'Industry',
      items: [
        'Innovating extraction and processing technologies',
        'Building resilient and transparent supply chains',
        'Collaborating on responsible mining standards'
      ]
    }
  };

  var ecosystemNodes = document.querySelectorAll('.eco-node-wrap');
  var ecoInfoTitle = document.getElementById('ecoInfoTitle');
  var ecoInfoList = document.getElementById('ecoInfoList');
  var bulletSrc = '../assets/images/ecosystem-bullet.svg';

  ecosystemNodes.forEach(function (node) {
    node.addEventListener('click', function () {
      var nodeKey = this.getAttribute('data-node');
      var data = ecosystemData[nodeKey];
      if (!data) return;

      // Update active state
      ecosystemNodes.forEach(function (n) { n.classList.remove('active'); });
      this.classList.add('active');

      // Update info panel
      if (ecoInfoTitle) ecoInfoTitle.textContent = data.title;
      if (ecoInfoList) {
        ecoInfoList.innerHTML = data.items.map(function (item) {
          return '<li><img src="' + bulletSrc + '" alt="" class="ecosystem-bullet">' + item + '</li>';
        }).join('');
      }
    });
  });

  // =====================
  // 8. Smooth scroll for anchors
  // =====================
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        var offset = window.innerWidth < 768 ? 120 : 80;
        var topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: topPos, behavior: 'smooth' });

        // Auto-select option in form if data-enquiry-type is provided
        var enquiryType = this.getAttribute('data-enquiry-type');
        if (enquiryType) {
          var selectEl = document.getElementById('enquiryType');
          if (selectEl) {
            selectEl.value = enquiryType;
          }
        }
      }
    });
  });



  // =====================
  // Forum Background video speed
  // =====================


  var forumPowerVideo = document.getElementById('forumPowerVideo');
  if (forumPowerVideo) {
    forumPowerVideo.playbackRate = 4.0;
  }





  // =====================
  // Cause Number counting animation
  // =====================
  (function initDiscoverCounters() {
    var discoverSection = document.querySelector('.discover-section');
    if (!discoverSection) return;

    var animated = false;

    function animateDiscoverCounters() {

      animated = true;

      discoverSection.querySelectorAll('.discover-stat').forEach(function (stat) {
        var unit = stat.querySelector('.discover-stat-unit');
        var unitText = unit ? unit.outerHTML : '';
        var fullText = stat.textContent.trim();

        // Extract prefix, number, suffix
        var prefix = '';
        var suffix = '';
        var numStr = fullText.replace(unit ? unit.textContent : '', '');

        if (numStr.startsWith('$')) {
          prefix = '$';
          numStr = numStr.slice(1);
        }

        var multiplier = 1;
        if (numStr.endsWith('k')) {
          suffix = 'k';
          numStr = numStr.slice(0, -1);
        } else if (numStr.endsWith('b')) {
          suffix = 'b';
          numStr = numStr.slice(0, -1);
        }

        var target = parseFloat(numStr);
        if (isNaN(target)) return;

        var duration = 2000;
        var startTime = null;

        function easeOutQuart(t) {
          return 1 - Math.pow(1 - t, 4);
        }

        function update(timestamp) {
          if (!startTime) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          var current = Math.floor(easeOutQuart(progress) * target);
          var display = current;
          stat.innerHTML = prefix + display + suffix + unitText;
          if (progress < 1) {
            requestAnimationFrame(update);
          } else {
            var finalDisplay = target;
            stat.innerHTML = prefix + finalDisplay + suffix + unitText;
          }
        }

        requestAnimationFrame(update);
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateDiscoverCounters();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(discoverSection);
  })();


  // =====================
  // CONTACT FORM SUBMISSION FOR FORUM PAGE
  // =====================
  var contactForm = document.getElementById('contactForm');
  var formMessage = contactForm && contactForm.closest('.contact-inner')
    ? contactForm.closest('.contact-inner').querySelector('#formMessage')
    : document.getElementById('formMessage');

  if (contactForm && contactForm.querySelector('#enquiryType') && contactForm.querySelector('#name') && contactForm.querySelector('#email')) {
    contactForm.dataset.interestFormHandled = 'true';

    var interestFormMessages = {
      enquiryType: contactForm.dataset.messageEnquiryType || 'Please select an inquiry type.',
      name: contactForm.dataset.messageName || 'Name should contain letters only, no digits.',
      email: contactForm.dataset.messageEmail || 'Please enter a valid email.',
      success: contactForm.dataset.messageSuccess || 'Thank you! Your interest has been registered.',
      submitting: contactForm.dataset.messageSubmitting || 'Submitting...',
      buttonText: contactForm.dataset.buttonText || ''
    };

    contactForm.style.display = '';
    contactForm.reset();
    if (formMessage) { formMessage.style.display = 'none'; formMessage.innerHTML = ''; }

    var interestSubmitButton = contactForm.querySelector('button[type="submit"]');
    var interestSubmitButtonLabel = interestSubmitButton ? Array.prototype.find.call(interestSubmitButton.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
    }) : null;
    var interestSubmitButtonText = interestFormMessages.buttonText || (interestSubmitButtonLabel ? interestSubmitButtonLabel.textContent.trim() : '');

    function setInterestSubmitButtonText(text) {
      if (!interestSubmitButton || !text) return;

      if (!interestSubmitButtonLabel) {
        interestSubmitButtonLabel = document.createTextNode('');
        interestSubmitButton.insertBefore(interestSubmitButtonLabel, interestSubmitButton.firstChild);
      }

      interestSubmitButtonLabel.textContent = text + ' ';
    }

    if (interestSubmitButton) {
      interestSubmitButton.disabled = false;
      setInterestSubmitButtonText(interestSubmitButtonText);
    }

    // ── Real-time digit blocking on the name field ──
    var nameInputEl = contactForm.querySelector('#name');
    if (nameInputEl) {
      // keydown: block digit keys before they appear (typing)
      nameInputEl.addEventListener('keydown', function (e) {
        if (e.key >= '0' && e.key <= '9') {
          e.preventDefault();
        }
      });
      // input: strip digits if pasted or auto-filled
      nameInputEl.addEventListener('input', function () {
        var pos = this.selectionStart;
        var cleaned = this.value.replace(/[0-9]/g, '');
        if (cleaned !== this.value) {
          this.value = cleaned;
          this.setSelectionRange(Math.max(0, pos - 1), Math.max(0, pos - 1));
        }
      });
    }

    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var enquiryTypeInput = contactForm.querySelector('#enquiryType');
      var nameInput = contactForm.querySelector('#name');
      var emailInput = contactForm.querySelector('#email');

      var enquiryType = enquiryTypeInput.value;
      var name = nameInput.value.trim();
      var email = emailInput.value.trim();

      var nameValid = name.length > 0 && !/[0-9<>@]/.test(name);
      var emailValid = email && emailInput.validity.valid;

      if (!enquiryType || !nameValid || !emailValid) {
        if (!formMessage) return;

        formMessage.style.display = 'block';
        formMessage.style.color = 'red';
        if (!enquiryType) {
          formMessage.textContent = interestFormMessages.enquiryType;
        } else if (!nameValid) {
          formMessage.textContent = interestFormMessages.name;
        } else {
          formMessage.textContent = interestFormMessages.email;
        }
        return;
      }

      if (interestSubmitButton) {
        interestSubmitButton.disabled = true;
        setInterestSubmitButtonText(interestFormMessages.submitting);
      }

      contactForm.reset();
      if (formMessage) {
        formMessage.style.display = 'block';
        formMessage.style.color = 'green';
        formMessage.textContent = interestFormMessages.success;

        // GTM: Track successful form submission
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 'event': 'eventtracker', 'custom_event_name': 'form_submission', 'page_url': window.location.href, 'page_name': document.body ? (document.body.getAttribute('data-body-class') || document.title) : document.title, 'click_cta_name': 'submit', 'form_type': 'contact_us_form', 'form_category': String(enquiryType || 'general_inquiry').toLowerCase().replace(/\s+/g, '_') }); } catch (e) { }

        setTimeout(function () {
          formMessage.style.display = 'none';
        }, 5000);
      }

      if (interestSubmitButton) {
        interestSubmitButton.disabled = false;
        setInterestSubmitButtonText(interestSubmitButtonText);
      }
    });
  }
  // =====================
  // CONTACT PAGE - GENERAL ENQUIRY FORM
  // =====================
  (function initGeneralEnquiryForm() {
    var form = document.getElementById('generalEnquiryForm');
    if (!form) return;

    var fullNameInput = document.getElementById('general-full-name');
    var emailInput = document.getElementById('general-email');
    var countryCodeInput = document.getElementById('general-country-code');
    var phoneInput = document.getElementById('general-phone');
    var messageInput = document.getElementById('general-message');
    var termsInput = document.getElementById('terms-general');
    var categoryInput = form.querySelector('[name="enquiryCategory"]');
    var statusMessage = document.getElementById('general-enquiry-status');

    function setFieldError(input, message, errorId, errorTarget) {
      var errorElement = document.getElementById(errorId);
      var target = errorTarget || input;

      target.classList.toggle('is-invalid', Boolean(message));
      input.setAttribute('aria-invalid', message ? 'true' : 'false');

      if (errorElement) {
        errorElement.textContent = message;
      }
    }

    function setStatus(message, type) {
      if (!statusMessage) return;

      statusMessage.textContent = message;
      statusMessage.classList.remove('is-error', 'is-success');

      if (message && type) {
        statusMessage.classList.add(type);
      }
    }

    function validateFullName() {
      var message = fullNameInput.value.trim() ? '' : 'Please enter your full name.';
      setFieldError(fullNameInput, message, 'general-full-name-error');
      return !message;
    }

    function validateEmail() {
      var value = emailInput.value.trim();
      var message = '';

      if (!value) {
        message = 'Please enter your email address.';
      } else if (!emailInput.validity.valid) {
        message = 'Please enter a valid email address.';
      }

      setFieldError(emailInput, message, 'general-email-error');
      return !message;
    }

    function validatePhone() {
      var value = phoneInput.value.trim();
      var message = '';

      if (!value) {
        message = 'Please enter your phone number.';
      } else if (phoneInput.iti && !phoneInput.iti.isValidNumber()) {
        message = 'Please enter a valid phone number.';
      }

      setFieldError(phoneInput, message, 'general-phone-error', phoneInput.closest('.phone-input'));
      return !message;
    }

    function validateTerms() {
      var message = termsInput.checked ? '' : 'You must agree to the Terms & Conditions before submitting.';
      setFieldError(termsInput, message, 'terms-general-error');
      return !message;
    }

    fullNameInput.addEventListener('input', validateFullName);
    emailInput.addEventListener('input', validateEmail);
    phoneInput.addEventListener('input', validatePhone);
    termsInput.addEventListener('change', validateTerms);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setStatus('', '');

      var fullNameValid = validateFullName();
      var emailValid = validateEmail();
      var phoneValid = validatePhone();
      var termsValid = validateTerms();
      var categoryValid = Boolean(categoryInput && categoryInput.value);

      if (!fullNameValid || !emailValid || !phoneValid || !termsValid || !categoryValid) {
        setStatus('Please complete all required fields before submitting.', 'is-error');

        var firstInvalidField = form.querySelector('[aria-invalid="true"]');
        if (firstInvalidField) {
          firstInvalidField.focus();
        }
        return;
      }

      var recipient = form.getAttribute('data-recipient') || 'support@fmf.com';
      var phoneNumber = countryCodeInput.value + ' ' + phoneInput.value.trim();
      var subject = categoryInput.value + ' - ' + fullNameInput.value.trim();
      var body = [
        'Enquiry category: ' + categoryInput.value,
        'Full name: ' + fullNameInput.value.trim(),
        'Email: ' + emailInput.value.trim(),
        'Phone: ' + phoneNumber,
        '',
        'Message:',
        messageInput.value.trim() || 'No message provided.'
      ].join('\n');
      var mailtoUrl = 'mailto:' + recipient
        + '?subject=' + encodeURIComponent(subject)
        + '&body=' + encodeURIComponent(body);

      setStatus('Your email application has been opened. Please send the prepared enquiry to complete your submission.', 'is-success');

      // GTM: Track successful form submission
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 'event': 'eventtracker', 'custom_event_name': 'form_submission', 'page_url': window.location.href, 'page_name': document.body ? (document.body.getAttribute('data-body-class') || document.title) : document.title, 'click_cta_name': 'submit', 'form_type': 'contact_us_form', 'form_category': String(categoryInput ? categoryInput.value : 'general_inquiry').toLowerCase().replace(/\s+/g, '_') }); } catch (e) { }

      window.location.href = mailtoUrl;
    });
  })();


  // =====================
  // 9. Strategic objectives accordion
  // =====================
  (function initStrategicObjectivesAccordions() {
    // Exclude the FMF 2027 Vision section — it has its own dedicated scroll logic
    // (see initVisionSectionScroll below). The About page section continues to use this shared handler.
    var strategicSections = Array.prototype.slice.call(document.querySelectorAll('.so-section'))
      .filter(function (s) { return s.id !== 'fmf2027VisionSection' && s.id !== 'fmf2027ContextSection'; });
    if (!strategicSections.length) return;

    function getScrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function getViewportHeight() {
      return window.innerHeight || document.documentElement.clientHeight || 0;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function createStrategicAccordion(section) {
      var accordion = section.querySelector('.so-accordion');
      var items = Array.prototype.slice.call(section.querySelectorAll('.so-item'));
      var image = section.querySelector('.so-image');
      var activeIndex = -1;
      var scrollStart = 0;
      var scrollEnd = 1;
      var imageFrame = null;
      var imageTimer = null;
      var clickScrollTimer = null;
      var ignoreScrollUntil = 0;
      var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 992px)') : null;

      if (!accordion || !items.length) return null;

      function isDesktop() {
        return !desktopQuery || desktopQuery.matches;
      }

      function clampIndex(index) {
        return clamp(index, 0, items.length - 1);
      }

      function cancelImageTransition() {
        if (imageFrame) {
          window.cancelAnimationFrame(imageFrame);
          imageFrame = null;
        }

        if (imageTimer) {
          window.clearTimeout(imageTimer);
          imageTimer = null;
        }

        if (image) {
          image.classList.remove('is-switching');
        }
      }

      function preloadImages() {
        items.forEach(function (item) {
          var src = item.getAttribute('data-so-image');
          if (!src) return;

          var preload = new Image();
          preload.src = src;
        });
      }

      function syncImage(src, skipAnimation) {
        if (!image || !src || image.getAttribute('src') === src) return;

        cancelImageTransition();

        if (skipAnimation) {
          image.setAttribute('src', src);
          return;
        }

        image.classList.add('is-switching');
        image.setAttribute('src', src);

        imageFrame = window.requestAnimationFrame(function () {
          imageFrame = window.requestAnimationFrame(function () {
            image.classList.remove('is-switching');
            imageFrame = null;
          });
        });

        imageTimer = window.setTimeout(function () {
          image.classList.remove('is-switching');
          imageTimer = null;
        }, 450);
      }

      function setPanelHeights() {
        items.forEach(function (item) {
          var body = item.querySelector('.so-item__body');
          var mobileImage = item.querySelector('.so-item__mobile-image');

          if (body) {
            body.style.setProperty('--so-panel-height', body.scrollHeight + 'px');
          }

          if (mobileImage) {
            mobileImage.style.setProperty('--so-mobile-image-height', mobileImage.scrollHeight + 'px');
          }
        });
      }

      function setAccordionStableHeight() {
        accordion.style.minHeight = '';

        if (!isDesktop()) return;

        var accordionRect = accordion.getBoundingClientRect();
        if (!accordionRect.width) return;

        var clone = accordion.cloneNode(true);
        var cloneItems;
        var maxHeight = 0;

        clone.classList.add('so-accordion--measuring');
        clone.style.position = 'absolute';
        clone.style.left = '-9999px';
        clone.style.top = '0';
        clone.style.width = accordionRect.width + 'px';
        clone.style.minHeight = '0';
        clone.style.visibility = 'hidden';
        clone.style.pointerEvents = 'none';

        section.appendChild(clone);
        cloneItems = Array.prototype.slice.call(clone.querySelectorAll('.so-item'));

        cloneItems.forEach(function (item, index) {
          cloneItems.forEach(function (cloneItem, cloneIndex) {
            var isActive = cloneIndex === index;
            cloneItem.classList.toggle('so-item--active', isActive);
            cloneItem.classList.toggle('so-item--collapsed', !isActive);
          });

          maxHeight = Math.max(maxHeight, clone.scrollHeight);
        });

        if (clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }

        if (maxHeight > 0) {
          accordion.style.minHeight = Math.ceil(maxHeight) + 'px';
        }
      }

      function refreshMeasurements() {
        var sectionRect;
        var sectionTop;
        var sectionHeight;
        var viewportHeight = getViewportHeight();
        var scrollY = getScrollY();

        setPanelHeights();
        setAccordionStableHeight();

        sectionRect = section.getBoundingClientRect();
        sectionTop = sectionRect.top + scrollY;
        sectionHeight = sectionRect.height;

        scrollStart = sectionTop - (viewportHeight * 0.7);
        scrollEnd = sectionTop + sectionHeight - (viewportHeight * 0.3);

        if (scrollEnd <= scrollStart) {
          scrollEnd = scrollStart + 1;
        }
      }

      function setStrategicAccordionState(index, options) {
        var activeItem;
        var nextImage;
        var normalizedIndex = clampIndex(index);
        var force = options && options.force;
        var skipImageAnimation = options && options.skipImageAnimation;

        if (!force && normalizedIndex === activeIndex) return;

        activeIndex = normalizedIndex;

        items.forEach(function (item, itemIndex) {
          var isActive = itemIndex === normalizedIndex;
          item.classList.toggle('so-item--active', isActive);
          item.classList.toggle('so-item--collapsed', !isActive);
          item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        activeItem = items[normalizedIndex];
        nextImage = activeItem ? activeItem.getAttribute('data-so-image') : null;
        syncImage(nextImage, skipImageAnimation);
      }

      function getIndexFromScroll() {
        var progress;

        if (items.length === 1) return 0;

        progress = clamp((getScrollY() - scrollStart) / (scrollEnd - scrollStart), 0, 1);
        return clampIndex(Math.floor(progress * items.length));
      }

      function updateFromScroll() {
        if (Date.now() < ignoreScrollUntil) return;

        if (!isDesktop()) {
          return; // Mobile: disabled auto-scroll-spy (accordion state is manual)
        }

        // Desktop scroll-spy logic
        setStrategicAccordionState(getIndexFromScroll());
      }

      function scrollToIndex(index) {
        var progress = items.length === 1 ? 0 : (clampIndex(index) + 0.5) / items.length;
        var targetY = scrollStart + ((scrollEnd - scrollStart) * progress);

        ignoreScrollUntil = Date.now() + 700;

        if (clickScrollTimer) {
          window.clearTimeout(clickScrollTimer);
        }

        clickScrollTimer = window.setTimeout(function () {
          ignoreScrollUntil = 0;
          updateFromScroll();
          clickScrollTimer = null;
        }, 720);

        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }

      function getInitialIndex() {
        var initialIndex = 0;

        items.forEach(function (item, index) {
          if (item.classList.contains('so-item--active')) {
            initialIndex = index;
          }
        });

        return initialIndex;
      }

      preloadImages();

      items.forEach(function (item, index) {
        item.addEventListener('click', function () {
          if (!isDesktop()) {
            // Mobile: allow independent toggling of accordions without collapsing others
            var isActive = item.classList.contains('so-item--active');
            item.classList.toggle('so-item--active', !isActive);
            item.classList.toggle('so-item--collapsed', isActive);
            item.setAttribute('aria-expanded', !isActive ? 'true' : 'false');
            return;
          }

          refreshMeasurements();
          setStrategicAccordionState(index);
          scrollToIndex(index);
        });

        item.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (!isDesktop()) {
              var isActive = item.classList.contains('so-item--active');
              item.classList.toggle('so-item--active', !isActive);
              item.classList.toggle('so-item--collapsed', isActive);
              item.setAttribute('aria-expanded', !isActive ? 'true' : 'false');
              return;
            }
            refreshMeasurements();
            setStrategicAccordionState(index);
            scrollToIndex(index);
          }
        });
      });

      setPanelHeights();
      setStrategicAccordionState(getInitialIndex(), { force: true, skipImageAnimation: true });
      refreshMeasurements();

      return {
        refresh: refreshMeasurements,
        update: updateFromScroll
      };
    }

    var strategicAccordions = strategicSections
      .map(createStrategicAccordion)
      .filter(Boolean);

    var scrollTicking = false;
    var refreshTicking = false;

    function updateStrategicAccordions() {
      strategicAccordions.forEach(function (instance) {
        instance.update();
      });
    }

    function queueScrollUpdate() {
      if (scrollTicking) return;
      scrollTicking = true;

      window.requestAnimationFrame(function () {
        updateStrategicAccordions();
        scrollTicking = false;
      });
    }

    function queueRefresh() {
      if (refreshTicking) return;
      refreshTicking = true;

      window.requestAnimationFrame(function () {
        strategicAccordions.forEach(function (instance) {
          instance.refresh();
        });
        updateStrategicAccordions();
        refreshTicking = false;
      });
    }

    if (!strategicAccordions.length) return;

    window.addEventListener('scroll', queueScrollUpdate, { passive: true });
    window.addEventListener('resize', queueRefresh);
    window.addEventListener('load', queueRefresh);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(queueRefresh).catch(function () { });
    }

    queueScrollUpdate();
  })();


  // =====================
  // 9c. FMF 2027 Vision Section — Desktop sticky-scroll accordion sequence
  // =====================
  // This powers the "Driving a Shared Global Vision" section on /fmf-2027.
  // On desktop (≥992px) it wraps .so-content in a sticky frame + scroll track so that
  // vertical page scrolling drives the accordion sequence — with NO window.scrollTo() calls.
  // Tablet / mobile accordions remain manually toggled (click / keydown) exactly as before.
  // =====================
  (function initVisionSectionScroll() {
    ['fmf2027VisionSection', 'fmf2027ContextSection'].forEach(function (sectionId) {
      var section = document.getElementById(sectionId);
      if (!section) return;

      var soContent = section.querySelector('.so-content');
      var items = Array.prototype.slice.call(section.querySelectorAll('.so-item'));
      var image = section.querySelector('.so-image');

      if (!soContent || !items.length) return;

      var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 992px)') : null;

      var activeIndex = -1;
      var scrollTrack = null;
      var stickyFrame = null;
      var spacer = null;
      var scrollStart = 0;
      var scrollRoom = 0;
      var initialized = false;
      var ticking = false;
      var imageTimer = null;
      var imageFrame = null;

      // ── Helpers ─────────────────────────────────────────────

      function isDesktop() {
        return !desktopQuery || desktopQuery.matches;
      }

      function clamp(v, lo, hi) {
        return Math.max(lo, Math.min(hi, v));
      }

      // Image cross-fade when the active accordion changes
      function syncImage(src, skipAnimation) {
        if (!image || !src || image.getAttribute('src') === src) return;
        if (imageTimer) { clearTimeout(imageTimer); imageTimer = null; }
        if (imageFrame) { cancelAnimationFrame(imageFrame); imageFrame = null; }

        if (skipAnimation) {
          image.setAttribute('src', src);
          return;
        }

        image.classList.add('is-switching');
        image.setAttribute('src', src);
        imageFrame = requestAnimationFrame(function () {
          imageFrame = requestAnimationFrame(function () {
            image.classList.remove('is-switching');
            imageFrame = null;
          });
        });
        imageTimer = setTimeout(function () {
          image.classList.remove('is-switching');
          imageTimer = null;
        }, 450);
      }

      // Pre-measure body heights so CSS max-height transitions animate correctly.
      // We temporarily set max-height:none inline so that collapsed items
      // (which have max-height:0 from CSS) are measured at their natural height.
      // Without this, body.scrollHeight returns 0 for collapsed items in Chrome,
      // causing --so-panel-height to be set to 0px and blocking mobile expand.
      function setPanelHeights() {
        items.forEach(function (item) {
          var body = item.querySelector('.so-item__body');
          if (!body) return;
          body.style.maxHeight = 'none';    // lift CSS constraint briefly
          var h = body.scrollHeight;        // now returns natural content height
          body.style.maxHeight = '';        // remove inline override; CSS rule takes back over
          if (h > 0) {
            body.style.setProperty('--so-panel-height', h + 'px');
          }
        });
      }

      // Kick-off image preloads so transitions feel instant
      function preloadImages() {
        items.forEach(function (item) {
          var src = item.getAttribute('data-so-image');
          if (!src) return;
          var img = new Image();
          img.src = src;
        });
      }

      // ── Accordion state ──────────────────────────────────────

      function setAccordionState(index, skipImageAnimation) {
        var clamped = clamp(index, 0, items.length - 1);
        if (clamped === activeIndex) return;
        activeIndex = clamped;

        items.forEach(function (item, i) {
          var isActive = i === clamped;
          item.classList.toggle('so-item--active', isActive);
          item.classList.toggle('so-item--collapsed', !isActive);
          item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        var activeItem = items[clamped];
        var nextSrc = activeItem ? activeItem.getAttribute('data-so-image') : null;
        syncImage(nextSrc, skipImageAnimation);
      }

      function buildDesktopStructure() {
        scrollTrack = document.createElement('div');
        scrollTrack.className = 'so-vision-scroll-track';

        stickyFrame = document.createElement('div');
        stickyFrame.className = 'so-vision-sticky-frame';

        spacer = document.createElement('div');
        spacer.className = 'so-vision-spacer';
        spacer.setAttribute('aria-hidden', 'true');

        soContent.parentNode.insertBefore(scrollTrack, soContent);
        scrollTrack.appendChild(stickyFrame);
        stickyFrame.appendChild(soContent);
        scrollTrack.appendChild(spacer);

        initialized = true;
      }

      function teardownDesktopStructure() {
        if (!initialized || !scrollTrack) return;
        scrollTrack.parentNode.insertBefore(soContent, scrollTrack);
        scrollTrack.parentNode.removeChild(scrollTrack);
        scrollTrack = null;
        stickyFrame = null;
        spacer = null;
        initialized = false;
        activeIndex = -1;
        // Remove inline --so-panel-height set during desktop init so that
        // mobile click expand uses the CSS fallback (900px) instead of 0px.
        items.forEach(function (item) {
          var body = item.querySelector('.so-item__body');
          if (body) body.style.removeProperty('--so-panel-height');
        });
      }

      // ── Measurements ─────────────────────────────────────────

      function refreshMeasurements() {
        if (!initialized || !scrollTrack || !spacer) return;

        scrollRoom = window.innerHeight * ((items.length - 1) * 0.6 + 0.5);
        spacer.style.height = scrollRoom + 'px';

        var trackRect = scrollTrack.getBoundingClientRect();
        scrollStart = trackRect.top + (window.pageYOffset || document.documentElement.scrollTop || 0);

        setPanelHeights();
      }

      // ── Scroll-driven accordion update ───────────────────────

      function updateFromScroll() {
        if (!isDesktop() || !initialized) return;
        var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var progress = clamp((scrollY - scrollStart) / scrollRoom, 0, 1);
        var index = clamp(Math.floor(progress * items.length), 0, items.length - 1);
        setAccordionState(index);
      }

      // ── Mobile click / keyboard ──────────────────────────────

      // On mobile we drive the accordion with inline styles so that the
      // expand/collapse never depends on --so-panel-height or CSS specificity.
      function mobileToggle(item) {
        var isActive = item.classList.contains('so-item--active');
        item.classList.toggle('so-item--active', !isActive);
        item.classList.toggle('so-item--collapsed', isActive);
        item.setAttribute('aria-expanded', String(!isActive));

        var body     = item.querySelector('.so-item__body');
        var mobileImg = item.querySelector('.so-item__mobile-image');

        if (!isActive) {
          // Expanding — set generous max-height so CSS transition plays
          if (body) {
            body.style.maxHeight = '2000px';
            body.style.opacity = '1';
            body.style.marginTop = '16px';
          }
          if (mobileImg) {
            mobileImg.style.maxHeight = '640px';
            mobileImg.style.opacity = '1';
            mobileImg.style.marginTop = '16px';
          }
        } else {
          // Collapsing
          if (body) {
            body.style.maxHeight = '0';
            body.style.opacity = '0';
            body.style.marginTop = '0';
          }
          if (mobileImg) {
            mobileImg.style.maxHeight = '0';
            mobileImg.style.opacity = '0';
            mobileImg.style.marginTop = '0';
          }
        }

      }

      items.forEach(function (item) {
        item.addEventListener('click', function () {
          if (isDesktop()) return;
          mobileToggle(item);
        });

        item.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          if (isDesktop()) return;
          mobileToggle(item);
        });
      });

      // ── Event listeners ──────────────────────────────────────

      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateFromScroll();
          ticking = false;
        });
      }, { passive: true });

      window.addEventListener('resize', function () {
        if (isDesktop()) {
          if (!initialized) {
            initDesktop();
          } else {
            refreshMeasurements();
            updateFromScroll();
          }
        } else {
          if (initialized) {
            teardownDesktopStructure();
            items.forEach(function (item, i) {
              var first = i === 0;
              item.classList.toggle('so-item--active', first);
              item.classList.toggle('so-item--collapsed', !first);
              item.setAttribute('aria-expanded', first ? 'true' : 'false');
            });
          }
        }
      });

      window.addEventListener('load', function () {
        if (isDesktop() && initialized) {
          refreshMeasurements();
          updateFromScroll();
        }
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          if (isDesktop() && initialized) {
            refreshMeasurements();
            updateFromScroll();
          }
        }).catch(function () { });
      }

      function initDesktop() {
        if (initialized) return;
        preloadImages();
        setPanelHeights();
        buildDesktopStructure();
        setAccordionState(0, true);
        refreshMeasurements();
        updateFromScroll();
      }

      if (isDesktop()) {
        initDesktop();
      }
    });
  })();


  // =====================
  // 9b. Lazy-load below-the-fold homepage video backgrounds
  // =====================
  (function initLazyBackgroundVideos() {
    var lazyVideos = document.querySelectorAll('video[data-src]');
    if (!lazyVideos.length) return;

    function loadVideo(video) {
      if (!video || video.dataset.loaded === 'true') return;

      var src = video.getAttribute('data-src');
      if (!src) return;

      video.src = src;
      video.dataset.loaded = 'true';
      video.load();

      if (video.muted) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () { });
        }
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          loadVideo(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '600px 0px' });

      lazyVideos.forEach(function (video) {
        observer.observe(video);
      });
    } else {
      lazyVideos.forEach(loadVideo);
    }
  })();

  // =====================
  // 10. Knowledge Hub - video player + thumb carousel
  // =====================
  (function initKnowledgeHub() {
    var knowledgePlayer = document.getElementById('knowledgePlayer');
    var playerVideo = document.getElementById('knowledgePlayerVideo');
    var playBtn = document.getElementById('playerPlayBtn');
    var bigPlay = document.getElementById('playerBigPlay');
    var muteBtn = document.getElementById('playerMuteBtn');
    var fullscreenBtn = document.getElementById('playerFullscreenBtn');
    var progressBar = document.getElementById('playerProgressBar');
    var progressFill = document.getElementById('playerProgressFill');
    var timeLabel = document.getElementById('playerTime');
    var thumbsContainer = document.getElementById('knowledgeThumbs');
    var thumbNavLeft = document.querySelector('.home-knowledge .thumb-nav-left');
    var thumbNavRight = document.querySelector('.home-knowledge .thumb-nav-right');
    var thumbCards = document.querySelectorAll('.home-knowledge .thumb-card');
    var knowledgeTabs = document.querySelectorAll('.home-knowledge .knowledge-tab');
    var knowledgePanels = document.querySelectorAll('.home-knowledge .knowledge-tab-panel');
    var isKnowledgeHubLibraryPage = /\/knowledge-hub\/library\/?$/.test(window.location.pathname) ||
      /\/knowledge-hub-library\.html$/.test(window.location.pathname);

    // ---- Tab switching ----
    knowledgeTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var selectedTab = tab.getAttribute('data-tab');

        knowledgeTabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });

        knowledgePanels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-tab-panel') === selectedTab;
          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
        });

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        if (isKnowledgeHubLibraryPage && selectedTab) {
          history.replaceState(null, null, window.location.pathname + '#' + selectedTab);
        }

        if (selectedTab !== 'fmf-tv' && typeof playerVideo !== 'undefined' && playerVideo && !playerVideo.paused) {
          playerVideo.pause();
        }
      });
    });
    // ---- Handle URL Hash for direct tab linking ----
    var hash = window.location.hash;
    if (hash) {
      var targetTabId = hash.replace('#', '');
      var targetTab = document.querySelector('.home-knowledge .knowledge-tab[data-tab="' + targetTabId + '"]');
      if (targetTab) {
        // Wait a brief moment for layout, then click and scroll
        setTimeout(function () {
          targetTab.click();
          var section = document.querySelector('.engagements-library-knowledge-hub');
          if (section) {
            var offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: offsetTop, behavior: 'smooth' });
          }
          if (!isKnowledgeHubLibraryPage) {
            history.replaceState(null, null, window.location.pathname);
          }
        }, 100);
      }
    }

    if (!knowledgePlayer || !playerVideo) return;
    function formatTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) return '0:00';
      var m = Math.floor(seconds / 60);
      var s = Math.floor(seconds % 60);
      return m + ':' + (s < 10 ? '0' + s : s);
    }

    function updateTimeLabel() {
      if (!timeLabel) return;
      timeLabel.textContent =
        formatTime(playerVideo.currentTime) + ' / ' + formatTime(playerVideo.duration || 0);
    }

    function updateProgressFill() {
      if (!progressFill || !playerVideo.duration) return;
      var pct = (playerVideo.currentTime / playerVideo.duration) * 100;
      progressFill.style.width = pct + '%';
    }

    function playVideo() {
      var p = playerVideo.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* autoplay blocked — ignore */ });
      }
    }

    playerVideo.addEventListener('play', function () {
      knowledgePlayer.setAttribute('data-state', 'playing');
      if (playBtn) playBtn.setAttribute('aria-label', 'Pause');
    });
    playerVideo.addEventListener('pause', function () {
      knowledgePlayer.setAttribute('data-state', 'paused');
      if (playBtn) playBtn.setAttribute('aria-label', 'Play');
    });
    playerVideo.addEventListener('timeupdate', function () {
      updateProgressFill();
      updateTimeLabel();
    });
    playerVideo.addEventListener('loadedmetadata', function () {
      updateTimeLabel();
      updateProgressFill();
    });
    playerVideo.addEventListener('ended', function () {
      knowledgePlayer.setAttribute('data-state', 'paused');
    });

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (playerVideo.paused) playVideo(); else playerVideo.pause();
      });
    }
    if (bigPlay) {
      bigPlay.addEventListener('click', function () {
        if (playerVideo.paused) playVideo(); else playerVideo.pause();
      });
    }

    // Click on video itself toggles play/pause
    playerVideo.addEventListener('click', function () {
      if (playerVideo.paused) playVideo(); else playerVideo.pause();
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        playerVideo.muted = !playerVideo.muted;
        knowledgePlayer.classList.toggle('is-muted', playerVideo.muted);
        muteBtn.setAttribute('aria-label', playerVideo.muted ? 'Unmute' : 'Mute');
      });
    }

    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', function () {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (knowledgePlayer.requestFullscreen) {
          knowledgePlayer.requestFullscreen();
        } else if (playerVideo.webkitEnterFullscreen) {
          playerVideo.webkitEnterFullscreen();
        }
      });
    }

    // Click on progress bar to seek
    function seekFromEvent(e) {
      if (!playerVideo.duration) return;
      var rect = progressBar.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      var ratio = Math.min(1, Math.max(0, x / rect.width));
      playerVideo.currentTime = ratio * playerVideo.duration;
      updateProgressFill();
    }
    if (progressBar) {
      progressBar.addEventListener('click', seekFromEvent);
    }

    function prepareThumbVideo(video) {
      if (!video || video.dataset.preloadStarted === 'true') return;

      video.dataset.preloadStarted = 'true';
      video.preload = 'metadata';
      video.load();
    }

    function playThumbPreview(video) {
      if (!video) return;

      function playFromPreviewFrame() {
        if (isFinite(video.duration) && video.duration > 8) {
          video.currentTime = 8;
        }

        var promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () { });
        }
      }

      prepareThumbVideo(video);

      if (video.readyState >= 2) {
        playFromPreviewFrame();
      } else {
        video.addEventListener('canplay', playFromPreviewFrame, { once: true });
      }
    }

    if ('IntersectionObserver' in window && thumbCards.length) {
      var thumbPreloadObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var video = entry.target.querySelector('.thumb-video');
          prepareThumbVideo(video);
          thumbPreloadObserver.unobserve(entry.target);
        });
      }, { rootMargin: '500px 0px' });

      thumbCards.forEach(function (card) {
        thumbPreloadObserver.observe(card);
      });
    }

    // ---- Thumb videos: hover autoplay muted + real duration ----
    thumbCards.forEach(function (card) {
      var video = card.querySelector('.thumb-video');
      var durationEl = card.querySelector('[data-duration]');

      if (video) {
        // Populate duration only after the lazy metadata request completes.
        function setDuration() {
          if (durationEl && isFinite(video.duration)) {
            durationEl.textContent = formatTime(video.duration);
          }
        }

        if (video.readyState >= 1) {
          setDuration();
        } else {
          video.addEventListener('loadedmetadata', setDuration);
        }

        // Hover autoplay (muted), leave pauses and rewinds
        card.addEventListener('mouseenter', function () {
          playThumbPreview(video);
        });
        card.addEventListener('mouseleave', function () {
          video.pause();
          if (isFinite(video.duration) && video.duration > 8) {
            video.currentTime = 8;
          }
        });
      }

      // Click to load into main player
      card.addEventListener('click', function () {
        thumbCards.forEach(function (c) { c.classList.remove('active'); });
        card.classList.add('active');
        var url = card.getAttribute('data-video-url');
        if (url && playerVideo) {
          playerVideo.src = url;
          playerVideo.load();
          playVideo();
        }
      });
    });


    // ---- Thumb carousel nav arrows + drag scroll ----
    if (thumbsContainer) {
      var scrollStep = 250;
      if (thumbNavLeft) {
        thumbNavLeft.addEventListener('click', function () {
          thumbsContainer.scrollTo({
            left: thumbsContainer.scrollLeft - scrollStep,
            behavior: 'smooth'
          });
        });
      }
      if (thumbNavRight) {
        thumbNavRight.addEventListener('click', function () {
          thumbsContainer.scrollTo({
            left: thumbsContainer.scrollLeft + scrollStep,
            behavior: 'smooth'
          });
        });
      }

      var isDown = false;
      var startX;
      var scrollLeftStart;
      thumbsContainer.addEventListener('mousedown', function (e) {
        isDown = true;
        startX = e.pageX - thumbsContainer.offsetLeft;
        scrollLeftStart = thumbsContainer.scrollLeft;
      });
      thumbsContainer.addEventListener('mouseleave', function () { isDown = false; });
      thumbsContainer.addEventListener('mouseup', function () { isDown = false; });
      thumbsContainer.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - thumbsContainer.offsetLeft;
        thumbsContainer.scrollLeft = scrollLeftStart - (x - startX) * 1.5;
      });
    }
  })();

  // =====================
  // 11. Initiatives pillar tab states
  // =====================
  var pillarTabs = document.querySelectorAll('.pillar-tab');

  if (pillarTabs.length > 0) {
    pillarTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        pillarTabs.forEach(function (tabItem) {
          tabItem.classList.remove('active');
          tabItem.setAttribute('aria-pressed', 'false');
        });

        this.classList.add('active');
        this.setAttribute('aria-pressed', 'true');
      });

      // Update URL hash when a tab is shown
      tab.addEventListener('shown.bs.tab', function (e) {
        var targetId = e.target.getAttribute('data-bs-target');
        if (targetId) {
          var cleanHash = targetId.replace('-tab', '');
          history.replaceState(null, null, cleanHash);
        }
      });
    });

    // Open specific tab on load based on URL hash
    var hash = window.location.hash;
    if (hash) {
      var targetTab = document.querySelector('.pillar-tab[data-bs-target="' + hash + '-tab"]');
      if (targetTab) {
        targetTab.click();
      }
    }
  }

  /* Legacy Knowledge Hub arrow/drag/play-button handlers were moved
     into the initKnowledgeHub IIFE above (section 10). */




  // Active nav link based on current page
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-links li a').forEach(function (link) {
    const href = link.getAttribute('href');
    if (!href || href === '#') return;

    try {
      const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
      const cleanCurrentPath = currentPath.replace(/\/$/, '');

      if (cleanCurrentPath === linkPath || cleanCurrentPath.startsWith(linkPath + '/')) {
        link.classList.add('active');
      }
    } catch (e) { }
  });








  // =====================
  // 11b. Barometer carousel — Slick fade + custom arrows
  // =====================
  var barometerSlider = $('#barometerSlider');
  var barometerArrowPrev = $('.barometer-arrow-prev');
  var barometerArrowNext = $('.barometer-arrow-next');

  if (barometerSlider.length > 0 && typeof barometerSlider.slick === 'function') {
    barometerSlider.slick({
      infinite: false,               /* disabled infinite loop */
      speed: 600,
      fade: true,
      cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: barometerArrowPrev,
      nextArrow: barometerArrowNext,
      dots: false,
      adaptiveHeight: false, /* was true */
      autoplay: true,               /* disabled autoplay as infinite loop is stopped */
      autoplaySpeed: 5000,           /* 5s per slide */
      pauseOnHover: true,
      pauseOnFocus: true,
      lazyLoad: 'ondemand'/*added */
    });

    function updateBarometerArrowStates() {
      var currentSlide = barometerSlider.slick('slickCurrentSlide');
      var totalSlides = barometerSlider.slick('getSlick').slideCount;

      if (currentSlide === 0) {
        barometerArrowPrev.addClass('is-disabled').removeClass('is-active');
        barometerArrowPrev.attr('disabled', 'disabled');
      } else {
        barometerArrowPrev.removeClass('is-disabled').addClass('is-active');
        barometerArrowPrev.removeAttr('disabled');
      }

      if (currentSlide >= totalSlides - 1) {
        barometerArrowNext.addClass('is-disabled').removeClass('is-active');
        barometerArrowNext.attr('disabled', 'disabled');
      } else {
        barometerArrowNext.removeClass('is-disabled').addClass('is-active');
        barometerArrowNext.removeAttr('disabled');
      }
    }

    updateBarometerArrowStates();

    barometerSlider.on('afterChange', function () {
      updateBarometerArrowStates();
    });
  }






  // =====================
  // 12. Channels carousel with Slick
  // =====================
  var channelsGrid = $('.channels-grid');
  var channelsArrowBtns = document.querySelectorAll('.channels-arrow-btn');
  var channelsProgressFill = document.querySelector('.channels-progress-fill');

  if (channelsGrid.length > 0) {
    channelsGrid.slick({
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    // Connect custom arrow buttons to Slick
    if (channelsArrowBtns.length >= 2) {
      var prevBtn = channelsArrowBtns[0];
      var nextBtn = channelsArrowBtns[1];

      prevBtn.addEventListener('click', function (e) {
        if (!this.classList.contains('is-disabled')) {
          channelsGrid.slick('slickPrev');
          updateChannelsProgress();
          updateArrowStates();
        }
        e.preventDefault();
      });

      nextBtn.addEventListener('click', function (e) {
        if (!this.classList.contains('is-disabled')) {
          channelsGrid.slick('slickNext');
          updateChannelsProgress();
          updateArrowStates();
        }
        e.preventDefault();
      });
    }

    // Update arrow states based on slider position
    function updateArrowStates() {
      var currentSlide = channelsGrid.slick('slickCurrentSlide');
      var totalSlides = channelsGrid.slick('getSlick').slideCount;
      var slidesToShow = channelsGrid.slick('getSlick').options.slidesToShow;
      var maxIndex = Math.max(0, totalSlides - slidesToShow);

      if (channelsArrowBtns.length >= 2) {
        var prevBtn = channelsArrowBtns[0];
        var nextBtn = channelsArrowBtns[1];

        // Update previous button
        if (currentSlide === 0) {
          prevBtn.classList.add('is-disabled');
          prevBtn.classList.remove('is-active');
        } else {
          prevBtn.classList.remove('is-disabled');
          prevBtn.classList.add('is-active');
        }

        // Update next button
        if (currentSlide >= maxIndex) {
          nextBtn.classList.add('is-disabled');
          nextBtn.classList.remove('is-active');
        } else {
          nextBtn.classList.remove('is-disabled');
          nextBtn.classList.add('is-active');
        }
      }
    }

    // Update progress bar
    function updateChannelsProgress() {
      var currentSlide = channelsGrid.slick('slickCurrentSlide');
      var totalSlides = channelsGrid.slick('getSlick').slideCount;
      var slidesToShow = channelsGrid.slick('getSlick').options.slidesToShow;
      var maxIndex = Math.max(0, totalSlides - slidesToShow);

      if (channelsProgressFill) {

        //ADDED THIS==
        var minPct = (1 / totalSlides) * 100;           // e.g. 25% for 4 cards
        var progress = maxIndex > 0
          ? minPct + (currentSlide / maxIndex) * (100 - minPct)
          : 100;
        channelsProgressFill.style.width = progress + '%';
      }
      //==============
    }

    // Initialize arrow states and progress
    updateArrowStates();
    updateChannelsProgress();

    // Update on slide change
    channelsGrid.on('afterChange', function () {
      updateArrowStates();
      updateChannelsProgress();
    });

    // Handle window resize for responsive changes
    window.addEventListener('resize', function () {
      setTimeout(function () {
        updateArrowStates();
        updateChannelsProgress();
      }, 100);
    });
  }

  // =====================
  // 12b. Media carousel with Slick
  // =====================
  var mediaSlider = $('.media-slider');
  var mediaArrowBtns = document.querySelectorAll('.media-arrow-btn');
  var mediaProgressFill = document.querySelector('.media-progress-fill');

  if (mediaSlider.length > 0) {
    mediaSlider.slick({
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    function updateMediaArrowStates() {
      var currentSlide = mediaSlider.slick('slickCurrentSlide');
      var totalSlides = mediaSlider.slick('getSlick').slideCount;
      var slidesToShow = mediaSlider.slick('getSlick').options.slidesToShow;
      var maxIndex = Math.max(0, totalSlides - slidesToShow);

      if (mediaArrowBtns.length >= 2) {
        var prevMediaBtn = mediaArrowBtns[0];
        var nextMediaBtn = mediaArrowBtns[1];

        if (currentSlide === 0) {
          prevMediaBtn.classList.add('is-disabled');
          prevMediaBtn.classList.remove('is-active');
        } else {
          prevMediaBtn.classList.remove('is-disabled');
          prevMediaBtn.classList.add('is-active');
        }

        if (currentSlide >= maxIndex) {
          nextMediaBtn.classList.add('is-disabled');
          nextMediaBtn.classList.remove('is-active');
        } else {
          nextMediaBtn.classList.remove('is-disabled');
          nextMediaBtn.classList.add('is-active');
        }
      }
    }

    function updateMediaProgress() {
      var currentSlide = mediaSlider.slick('slickCurrentSlide');
      var totalSlides = mediaSlider.slick('getSlick').slideCount;
      var slidesToShow = mediaSlider.slick('getSlick').options.slidesToShow;

      if (mediaProgressFill) {
        var minPct = (1 / totalSlides) * 100;
        var maxIndex = Math.max(0, totalSlides - slidesToShow);
        var progress = maxIndex > 0
          ? minPct + (currentSlide / maxIndex) * (100 - minPct)
          : 100;
        mediaProgressFill.style.width = progress + '%';
      }
    }

    if (mediaArrowBtns.length >= 2) {
      var mediaPrevBtn = mediaArrowBtns[0];
      var mediaNextBtn = mediaArrowBtns[1];

      mediaPrevBtn.addEventListener('click', function (e) {
        if (!this.classList.contains('is-disabled')) {
          mediaSlider.slick('slickPrev');
        }
        e.preventDefault();
      });

      mediaNextBtn.addEventListener('click', function (e) {
        if (!this.classList.contains('is-disabled')) {
          mediaSlider.slick('slickNext');
        }
        e.preventDefault();
      });
    }

    updateMediaArrowStates();
    updateMediaProgress();

    mediaSlider.on('afterChange', function () {
      updateMediaArrowStates();
      updateMediaProgress();
    });

    window.addEventListener('resize', function () {
      setTimeout(function () {
        updateMediaArrowStates();
        updateMediaProgress();
      }, 100);
    });
  }

  // Footer blob scroll animation
  const footerBlob = document.querySelector('.footer-blob');
  if (footerBlob) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          footerBlob.classList.add('is-visible');
          observer.disconnect(); // fire once
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(footerBlob.closest('.footer-blob-wrap'));
  }

  // Engagement carousel
  var engagementTrack = document.getElementById('engagementTrack');
  var engagementFill = document.getElementById('engagementFill');
  var engagementPrevBtn = document.getElementById('engagementPrev');
  var engagementNextBtn = document.getElementById('engagementNext');

  function updateEngagementProgress() {
    if (!engagementTrack) return;

    var scrollLeft = engagementTrack.scrollLeft;
    var maxScroll = engagementTrack.scrollWidth - engagementTrack.clientWidth;

    if (engagementFill) {
      var progress = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
      engagementFill.style.width = Math.max(10, progress) + '%';
    }

    if (engagementPrevBtn) {
      if (scrollLeft > 10) {
        engagementPrevBtn.classList.add('enabled', 'active');
        engagementPrevBtn.classList.remove('disabled');
        engagementPrevBtn.removeAttribute('disabled');
      } else {
        engagementPrevBtn.classList.remove('enabled', 'active');
        engagementPrevBtn.classList.add('disabled');
        engagementPrevBtn.setAttribute('disabled', 'true');
      }
    }
    if (engagementNextBtn) {
      if (maxScroll <= 0 || scrollLeft >= maxScroll - 10) {
        engagementNextBtn.classList.remove('enabled', 'active');
        engagementNextBtn.classList.add('disabled');
        engagementNextBtn.setAttribute('disabled', 'true');
      } else {
        engagementNextBtn.classList.add('enabled', 'active');
        engagementNextBtn.classList.remove('disabled');
        engagementNextBtn.removeAttribute('disabled');
      }
    }
  }

  if (engagementTrack) {
    engagementTrack.addEventListener('scroll', updateEngagementProgress);
    // Call initially and on resize to set default navigation arrow state
    window.addEventListener('load', updateEngagementProgress);
    window.addEventListener('resize', updateEngagementProgress);
    setTimeout(updateEngagementProgress, 300); //was 100

    // Recalculate when the engagement tab becomes visible
    var engagementTabBtn = document.querySelector('button[data-bs-target="#engagement-tab"]');
    if (engagementTabBtn) {
      engagementTabBtn.addEventListener('shown.bs.tab', function () {
        // small delay to ensure display: block is fully rendered
        setTimeout(updateEngagementProgress, 50);
      });
    }
  }

  if (engagementPrevBtn) {
    engagementPrevBtn.addEventListener('click', function () {
      engagementTrack.scrollBy({ left: -340, behavior: 'smooth' });
    });
  }

  if (engagementNextBtn) {
    engagementNextBtn.addEventListener('click', function () {
      engagementTrack.scrollBy({ left: 340, behavior: 'smooth' });
    });
  }


  // Nav shadow on scroll
  var mainNav = document.getElementById('mainNav');
  window.addEventListener('scroll', function () {
    if (mainNav) {
      if (window.scrollY > 10) {
        mainNav.classList.add('scrolled');
      } else {
        mainNav.classList.remove('scrolled');
      }
    }
  }, { passive: true });

  // Diamond diagram interaction
  var reportSection = document.querySelector('.report-section');

  if (reportSection) {
    var diamondItems = reportSection.querySelectorAll('.report-diagram .diamond-item');
    var diamondTitle = reportSection.querySelector('#diamondTitle');
    var diamondDesc = reportSection.querySelector('#diamondDesc');
    var accordionItems = reportSection.querySelectorAll('.report-accordion-item');
    var accordionTriggers = reportSection.querySelectorAll('.report-accordion-trigger');

    function setReportContent(title, desc) {
      if (diamondTitle && diamondDesc) {
        diamondTitle.innerHTML = title;
        diamondDesc.textContent = desc;
      }
    }

    function setActiveDiamond(activeItem) {
      if (!activeItem) return;

      diamondItems.forEach(function (item) {
        var isActive = item === activeItem;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        var shape = item.querySelector('.diamond-shape');
        if (shape) {
          shape.classList.toggle('active', isActive);
        }
      });

      setReportContent(activeItem.getAttribute('data-title'), activeItem.getAttribute('data-desc'));
    }

    function setActiveAccordion(activeTrigger) {
      if (!activeTrigger) return;

      accordionItems.forEach(function (item) {
        var trigger = item.querySelector('.report-accordion-trigger');
        var panel = item.querySelector('.report-accordion-panel');
        var icon = item.querySelector('.report-accordion-icon');
        var isActive = trigger === activeTrigger;

        item.classList.toggle('is-open', isActive);
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');

        if (panel) {
          panel.hidden = !isActive;
        }

        if (icon) {
          icon.classList.toggle('is-active', isActive);
        }
      });
    }

    diamondItems.forEach(function (item) {
      item.addEventListener('click', function () {
        setActiveDiamond(item);
      });
    });

    accordionTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setActiveAccordion(trigger);
      });
    });

    var initialDiamond = reportSection.querySelector('.report-diagram .diamond-item.is-active') || diamondItems[0];
    var initialAccordion = reportSection.querySelector('.report-accordion-item.is-open .report-accordion-trigger') || accordionTriggers[0];

    setActiveDiamond(initialDiamond);
    setActiveAccordion(initialAccordion);
  }

  // Leaders carousel
  var leadersTrack = $('#leadersTrack');
  var leadersFill = document.getElementById('leadersFill');
  var leadersPrevBtn = document.getElementById('leadersPrev');
  var leadersNextBtn = document.getElementById('leadersNext');

  if (leadersTrack.length > 0 && typeof leadersTrack.slick === 'function') {
    leadersTrack.slick({
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      adaptiveHeight: false,
      touchThreshold: 12,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true
          }
        }
      ]
    });

    function updateLeadersArrowStates() {
      if (!leadersPrevBtn || !leadersNextBtn) return;

      var currentSlide = leadersTrack.slick('slickCurrentSlide');
      var slickInstance = leadersTrack.slick('getSlick');
      var totalSlides = slickInstance.slideCount;
      var slidesToShow = slickInstance.options.slidesToShow;
      var maxIndex = Math.max(0, totalSlides - slidesToShow);

      if (currentSlide === 0) {
        leadersPrevBtn.classList.remove('enabled');
      } else {
        leadersPrevBtn.classList.add('enabled');
      }

      if (currentSlide >= maxIndex) {
        leadersNextBtn.classList.remove('enabled');
      } else {
        leadersNextBtn.classList.add('enabled');
      }
    }

    function updateLeadersProgress() {
      if (!leadersFill) return;

      var currentSlide = leadersTrack.slick('slickCurrentSlide');
      var slickInstance = leadersTrack.slick('getSlick');
      var totalSlides = slickInstance.slideCount;
      var slidesToShow = slickInstance.options.slidesToShow;
      var maxIndex = Math.max(0, totalSlides - slidesToShow);
      var minPct = totalSlides > 0 ? (slidesToShow / totalSlides) * 100 : 100;
      var progress = maxIndex > 0
        ? minPct + (currentSlide / maxIndex) * (100 - minPct)
        : 100;

      leadersFill.style.width = progress + '%';
    }

    if (leadersPrevBtn) {
      leadersPrevBtn.addEventListener('click', function (e) {
        if (!this.classList.contains('enabled')) {
          e.preventDefault();
          return;
        }

        leadersTrack.slick('slickPrev');
        e.preventDefault();
      });
    }

    if (leadersNextBtn) {
      leadersNextBtn.addEventListener('click', function (e) {
        if (!this.classList.contains('enabled')) {
          e.preventDefault();
          return;
        }

        leadersTrack.slick('slickNext');
        e.preventDefault();
      });
    }

    updateLeadersArrowStates();
    updateLeadersProgress();

    leadersTrack.on('afterChange setPosition breakpoint', function () {
      updateLeadersArrowStates();
      updateLeadersProgress();
    });

    window.addEventListener('resize', function () {
      setTimeout(function () {
        updateLeadersArrowStates();
        updateLeadersProgress();
      }, 50);
    });
  }

  //==========ADDED==========

  // Auto-scroll pillar tabs when clicked
  document.querySelectorAll('.pillar-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tabList = document.querySelector('.pillar-tabs');
      if (!tabList) return;

      var tabRect = tab.getBoundingClientRect();
      var listRect = tabList.getBoundingClientRect();

      var scrollTo = tabList.scrollLeft + (tabRect.left - listRect.left) - (listRect.width / 2) + (tabRect.width / 2);

      tabList.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
    });
  });

  (function initForumVisibilitySection() {
    var section = document.querySelector('.forum-visibility-section');
    if (!section) return;

    var tabs = section.querySelectorAll('.forum-visibility-tab');
    var panels = section.querySelectorAll('.forum-visibility-panel');
    var accordionItems = section.querySelectorAll('.forum-visibility-accordion-item');
    var accordionTriggers = section.querySelectorAll('.forum-visibility-accordion-trigger');

    function animatePanel(panel) {
      if (!panel) return;
      panel.classList.remove('is-animate');
      window.requestAnimationFrame(function () {
        panel.classList.add('is-animate');
      });
    }

    function activateDesktopPanel(target) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-target') === target;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-panel') === target;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        if (!isActive) panel.classList.remove('is-animate');
      });

      animatePanel(section.querySelector('.forum-visibility-panel[data-panel="' + target + '"]'));
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateDesktopPanel(tab.getAttribute('data-target'));
      });
    });

    function closeAccordionItem(item) {
      var trigger = item.querySelector('.forum-visibility-accordion-trigger');
      var panel = item.querySelector('.forum-visibility-accordion-panel');
      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.hidden = true;
        panel.classList.remove('is-animate');
      }
    }

    function openAccordionItem(item) {
      var trigger = item.querySelector('.forum-visibility-accordion-trigger');
      var panel = item.querySelector('.forum-visibility-accordion-panel');
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.hidden = false;
        animatePanel(panel);
      }
    }

    accordionTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.forum-visibility-accordion-item');
        var isOpen = item && item.classList.contains('is-open');
        accordionItems.forEach(closeAccordionItem);
        if (!isOpen && item) {
          openAccordionItem(item);
        }
      });
    });

    var initialDesktop = section.querySelector('.forum-visibility-tab.is-active');
    if (initialDesktop) {
      activateDesktopPanel(initialDesktop.getAttribute('data-target'));
    }

    var initialAccordion = section.querySelector('.forum-visibility-accordion-item.is-open');
    if (initialAccordion) {
      openAccordionItem(initialAccordion);
    }
  })();

  // =====================
  // Horizontal Scroll for Contact Tabs on Mobile
  // =====================
  (function initContactTabsScroll() {
    var contactTabs = document.querySelector('.contact-tabs');
    if (!contactTabs) return;

    var tabBtns = contactTabs.querySelectorAll('.tab-btn');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.innerWidth < 768) {
          var containerLeft = contactTabs.getBoundingClientRect().left;
          var btnLeft = btn.getBoundingClientRect().left;
          var btnWidth = btn.offsetWidth;
          var containerWidth = contactTabs.offsetWidth;

          var scrollOffset = btnLeft - containerLeft - (containerWidth / 2) + (btnWidth / 2);

          contactTabs.scrollBy({
            left: scrollOffset,
            behavior: 'smooth'
          });
        }
      });
    });
  })();

  // =====================
  // Sponsors Listing Tabs
  // =====================
  (function initSponsorsTabs() {
    var tabBtns = document.querySelectorAll('.sponsors-tabs__btn');
    var tabContents = document.querySelectorAll('.sponsors-tab-content');
    if (!tabBtns.length) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.getAttribute('data-tab');

        tabBtns.forEach(function (b) { b.classList.remove('active'); });
        tabContents.forEach(function (c) { c.classList.remove('active'); });

        btn.classList.add('active');
        var activeContent = document.querySelector('.sponsors-tab-content[data-content="' + target + '"]');
        if (activeContent) activeContent.classList.add('active');

        // Centre the clicked tab inside the scrollable tab bar so the
        // user can see neighbouring tabs on both sides (mobile UX)
        var tabsContainer = btn.closest('.sponsors-tabs');
        if (tabsContainer) {
          var btnCenter = btn.offsetLeft + btn.offsetWidth / 2;
          var containerCenter = tabsContainer.offsetWidth / 2;
          tabsContainer.scrollTo({ left: btnCenter - containerCenter, behavior: 'smooth' });
        }
      });
    });
  })();


      // =====================
      // Speakers Hero Tabs
      // =====================
      (function initSpeakersHeroTabs() {
        var tabs = document.querySelectorAll('.speakers-hero-tab');
        if (!tabs.length) return;

        tabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            tabs.forEach(function(t) {
              t.classList.remove('is-active');
            });
            tab.classList.add('is-active');
          });
        });
      })();

      // =====================
      // Speakers Search Toggle + Filter
      // =====================
      (function initSpeakersSearch() {
        var toggleBtn = document.getElementById('speakersSearchToggle');
        var closeBtn = document.getElementById('speakersSearchClose');
        var nav = document.getElementById('speakersHeroNav');
        var searchBar = document.getElementById('speakersSearch');
        var input = document.getElementById('speakersSearchInput');
        if (!toggleBtn || !closeBtn || !nav || !searchBar || !input) return;

        toggleBtn.addEventListener('click', function () {
          nav.classList.add('is-hidden');
          searchBar.classList.add('is-active');
          input.focus();
        });

        closeBtn.addEventListener('click', function () {
          searchBar.classList.remove('is-active');
          nav.classList.remove('is-hidden');
          input.value = '';
          filterSpeakers('');
        });

        function filterSpeakers(query) {
          var q = query.trim().toLowerCase();
          var cards = document.querySelectorAll('.speaker-card');
          var matchCount = 0;

          cards.forEach(function (card) {
            var nameEl = card.querySelector('.speaker-card-name');
            var name = nameEl ? nameEl.textContent.toLowerCase() : '';
            var isMatch = q === '' || name.indexOf(q) !== -1;
            card.style.display = isMatch ? '' : 'none';
            if (isMatch) matchCount++;
          });

          var noResultsEl = document.getElementById('speakersNoResults');
          if (noResultsEl) {
            noResultsEl.style.display = (q !== '' && matchCount === 0) ? 'block' : 'none';
          }
        }

        input.addEventListener('input', function () {
          filterSpeakers(input.value);
        });
      })();

      // =====================
      // Speaker Card Modal Open/Close
      // =====================
      (function initSpeakerModal() {
        document.addEventListener('click', function (e) {
          var card = e.target.closest('.speaker-card[data-modal-target]');
          if (card) {
            var modal = document.getElementById(card.getAttribute('data-modal-target'));
            if (modal) {
              modal.classList.add('is-active');
              document.body.style.overflow = 'hidden';
            }
            return;
          }

          var closeBtn = e.target.closest('.speaker-modal-close');
          if (closeBtn) {
            closeBtn.closest('.speaker-modal-overlay').classList.remove('is-active');
            document.body.style.overflow = '';
            return;
          }

          if (e.target.classList.contains('speaker-modal-overlay')) {
            e.target.classList.remove('is-active');
            document.body.style.overflow = '';
          }
        });
      })();   

      // Toggle Leader RTL Mode (about-leaders.hbs)
      // =====================
      window.toggleLeaderRTL = function toggleLeaderRTL(btn) {
        const modalInner = btn.closest('.leader-modal-inner');
        if (modalInner) {
          const englishContent = modalInner.querySelector('.leader-modal-content.english');
          const arabicContent = modalInner.querySelector('.leader-modal-content.arabic');
          if (modalInner.getAttribute('dir') === 'rtl') {
            modalInner.removeAttribute('dir');
            modalInner.classList.remove('rtl-mode');
            if (englishContent) {
              englishContent.style.display = 'flex';
            }
            if (arabicContent) {
              arabicContent.style.setProperty('display', 'none', 'important');
            }
            modalInner.querySelector('.arabic-cta-text').innerHTML = "عرض باللغة العربية";
          } else {
            modalInner.setAttribute('dir', 'rtl');
            modalInner.classList.add('rtl-mode');
            if (englishContent) {
              englishContent.style.setProperty('display', 'none', 'important');
            }
            if (arabicContent) {
              arabicContent.style.display = 'flex';
            }
            modalInner.querySelector('.arabic-cta-text').innerHTML = "View in English";
          }
        }
      };
  // Toggle Leader RTL Mode (about-leaders.hbs)
  // =====================
  window.toggleLeaderRTL = function toggleLeaderRTL(btn) {
    const modalInner = btn.closest('.leader-modal-inner');
    if (modalInner) {
      const englishContent = modalInner.querySelector('.leader-modal-content.english');
      const arabicContent = modalInner.querySelector('.leader-modal-content.arabic');
      if (modalInner.getAttribute('dir') === 'rtl') {
        modalInner.removeAttribute('dir');
        modalInner.classList.remove('rtl-mode');
        if (englishContent) {
          englishContent.style.display = 'flex';
        }
        if (arabicContent) {
          arabicContent.style.setProperty('display', 'none', 'important');
        }
        modalInner.querySelector('.arabic-cta-text').innerHTML = "عرض باللغة العربية";
      } else {
        modalInner.setAttribute('dir', 'rtl');
        modalInner.classList.add('rtl-mode');
        if (englishContent) {
          englishContent.style.setProperty('display', 'none', 'important');
        }
        if (arabicContent) {
          arabicContent.style.display = 'flex';
        }
        modalInner.querySelector('.arabic-cta-text').innerHTML = "View in English";
      }
    }
  };

  // =====================
  // Knowledge Hub Info Cards & Pagination (knowledge-infocards.hbs)
  // =====================
  (function initKnowledgeInfoCards() {
    if (!document.querySelector('.engagements-library-knowledge-hub')) return;

    window.addEventListener('load', () => {
      const videos = document.querySelectorAll('.thumb-video');

      videos.forEach(video => {
        const handleMetadata = () => {
          // Update duration
          const durationSpan = video.closest('.video-thumb')?.querySelector('.thumb-duration');
          if (durationSpan && !isNaN(video.duration) && video.duration > 0) {
            const minutes = Math.floor(video.duration / 60);
            const seconds = Math.floor(video.duration % 60);
            durationSpan.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
          }

          video.currentTime = 0; // Show from the very beginning

          video.play().then(() => {
            video.pause(); // freeze at that frame
          }).catch(() => {
            // autoplay blocked → fallback
          });
        };

        if (video.readyState >= 1) { // HAVE_METADATA
          handleMetadata();
        } else {
          video.addEventListener('loadedmetadata', handleMetadata);
        }
      });

      const videoModalEl = document.getElementById('videoModal');
      const modalVideoPlayer = document.getElementById('modalVideoPlayer');

      if (videoModalEl && modalVideoPlayer) {
        videoModalEl.addEventListener('show.bs.modal', (e) => {
          const card = e.relatedTarget;
          if (card) {
            const thumbVideo = card.querySelector('.thumb-video');
            if (thumbVideo) {
              modalVideoPlayer.src = thumbVideo.getAttribute('src');
            }
          }
        });

        videoModalEl.addEventListener('shown.bs.modal', () => {
          modalVideoPlayer.play();
        });

        videoModalEl.addEventListener('hidden.bs.modal', () => {
          modalVideoPlayer.pause();
          modalVideoPlayer.currentTime = 0;
        });
      }

      // Pagination Logic
      const paginationItems = document.querySelectorAll('#fmfTvPagination .page-item');

      function showPage(page) {
        const videoCards = document.querySelectorAll('#knowledge-panel-fmf-tv .fmf-video-card');
        videoCards.forEach((card, index) => {
          const col = card.closest('.col-12');
          if (page === 1) {
            if (index < 6) col.classList.remove('d-none');
            else col.classList.add('d-none');
          } else if (page === 2) {
            if (index >= 6) col.classList.remove('d-none');
            else col.classList.add('d-none');
          }
        });

        paginationItems.forEach(item => {
          if (parseInt(item.getAttribute('data-page')) === page) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      }

      if (paginationItems.length > 0) {
        showPage(1); // Initialize page 1
        paginationItems.forEach(item => {
          item.addEventListener('click', () => {
            const page = parseInt(item.getAttribute('data-page'));
            showPage(page);
          });
        });
      }
    });
  })();

  // =====================
  // Forum dropdown Sub-Headings for tabs
  // =====================

  document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');

    if (tab) {
      // Remove active from all
      document.querySelectorAll('.sponsors-tabs__btn').forEach(btn => btn.classList.remove('active'));
      document.querySelectorAll('.sponsors-tab-content').forEach(content => content.classList.remove('active'));

      // Activate the matching tab
      const activeBtn = document.querySelector(`.sponsors-tabs__btn[data-tab="${tab}"]`);
      const activeContent = document.querySelector(`.sponsors-tab-content[data-content="${tab}"]`);

      if (activeBtn) activeBtn.classList.add('active');
      if (activeContent) activeContent.classList.add('active');
    }
  });

  // =====================
  // Contact Form Validation (home-contact.hbs)
  // =====================
  (function initContactForm() {
    const contactForm = document.getElementById("contactForm");
    if (!contactForm || contactForm.dataset.interestFormHandled === "true") return;
    if (!document.getElementById("formMessage") || !contactForm.querySelector("#enquiryType") || !contactForm.querySelector("#email") || !contactForm.querySelector("#name")) return;

    // ── Real-time: strip any digit the user types into the name field ──
    const nameEl = document.getElementById("name");
    if (nameEl) {
      nameEl.addEventListener("input", function () {
        // Remove digits immediately so users get instant feedback
        const pos = this.selectionStart;
        const cleaned = this.value.replace(/[0-9]/g, "");
        if (cleaned !== this.value) {
          this.value = cleaned;
          // Restore cursor position after the replacement
          this.setSelectionRange(Math.max(0, pos - 1), Math.max(0, pos - 1));
        }
      });
    }

    contactForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const formEl = this;
      const messageEl = document.getElementById("formMessage");
      if (!messageEl) return;

      const submitBtn = formEl.querySelector("button[type='submit']");

      messageEl.style.display = "none";
      messageEl.innerHTML = "";

      const enquiryTypeEl = document.getElementById("enquiryType");
      const emailEl = document.getElementById("email");
      const nameEl2 = document.getElementById("name");

      if (!enquiryTypeEl || !emailEl || !nameEl2) return;

      const enquiryType = enquiryTypeEl.value.trim();
      const email = emailEl.value.trim();
      const name = nameEl2.value.trim();

      if (!email || !name || !enquiryType) {
        showMessage("Please fill all required fields.", "error");
        return;
      }

      const emailValid = email.indexOf("@") > -1 && email.indexOf(".") > -1;
      if (!emailValid) {
        showMessage("Please enter a valid email address.", "error");
        return;
      }

      // Unicode-aware: allows letters from any script (Latin, Arabic, etc.)
      // plus spaces, hyphens, apostrophes, and dots (common in real names)
      const nameValid = /^[\p{L}\s'\-.]+$/u.test(name);
      if (!nameValid) {
        // Use the localised message from the form's data attribute if present
        const nameMsg = formEl.getAttribute("data-message-name") || "Full name should contain letters only, no digits.";
        showMessage(nameMsg, "error");
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = "Submitting...";
      }

      showMessage("Thank you! Your enquiry has been submitted.", "success");

      // GTM: Track successful form submission
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 'event': 'eventtracker', 'custom_event_name': 'form_submission', 'page_url': window.location.href, 'page_name': document.body ? (document.body.getAttribute('data-body-class') || document.title) : document.title, 'click_cta_name': 'submit', 'form_type': 'contact_us_form', 'form_category': String(enquiryType || 'general_inquiry').toLowerCase().replace(/\s+/g, '_') }); } catch (e) { }

      contactForm.style.display = "none";

      function showMessage(msg, type) {
        messageEl.style.display = "block";
        messageEl.innerHTML = msg;
        messageEl.style.color = type === "success" ? "green" : "red";
      }
    });
  })();

  // =====================
  // Conference Track Progress & Navigation (conference-overview-who-hear.hbs)
  // =====================
  (function initConferenceTrack() {

    var track = document.getElementById('conferenceTrack');
    var fill = document.getElementById('conferenceFill');
    var prevBtn = document.getElementById('conferencePrev');
    var nextBtn = document.getElementById('conferenceNext');

    if (!track) return;

    function updateProgress() {
      if (!track) return;

      // In RTL, scrollLeft is typically negative. Use Math.abs.
      var scrollLeft = Math.abs(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (fill) {
        var progress = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
        fill.style.width = Math.max(10, progress) + '%';
      }

      if (prevBtn) {
        if (scrollLeft > 10) {
          prevBtn.classList.add('enabled', 'active');
          prevBtn.classList.remove('disabled');
          prevBtn.removeAttribute('disabled');
        } else {
          prevBtn.classList.remove('enabled', 'active');
          prevBtn.classList.add('disabled');
          prevBtn.setAttribute('disabled', 'true');
        }
      }
      if (nextBtn) {
        if (maxScroll <= 0 || scrollLeft >= maxScroll - 10) {
          nextBtn.classList.remove('enabled', 'active');
          nextBtn.classList.add('disabled');
          nextBtn.setAttribute('disabled', 'true');
        } else {
          nextBtn.classList.add('enabled', 'active');
          nextBtn.classList.remove('disabled');
          nextBtn.removeAttribute('disabled');
        }
      }
    }

    track.addEventListener('scroll', updateProgress);
    window.addEventListener('load', updateProgress);
    window.addEventListener('resize', updateProgress);
    setTimeout(updateProgress, 300);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        // Prev in RTL goes Right (+ left)
        track.scrollBy({ left: 340, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        // Next in RTL goes Left (- left)
        track.scrollBy({ left: -340, behavior: 'smooth' });
      });
    }

  })();

  // =====================
  // Leadership Grid expansion (about-leadership-content.hbs)
  // =====================
  (function initLeadershipGrid() {

    // CONFIGURATION variables - easy to change!
    const INITIAL_CARDS = 6;
    const LOAD_MORE_COUNT = 3;

    function initGrid(gridId) {
      const grid = document.getElementById(gridId);
      if (!grid) return;

      const items = grid.querySelectorAll('.leadership-grid-item');
      // Find the load more button in the parent container
      const loadMoreBtn = grid.parentElement.querySelector('.load-more-btn');

      let visibleCount = INITIAL_CARDS;

      // Hide items beyond initial count
      items.forEach((item, index) => {
        if (index >= visibleCount) {
          item.style.display = 'none';
        } else {
          item.style.display = 'flex';
        }
      });

      // Hide button if no more items to show
      if (loadMoreBtn) {
        if (visibleCount >= items.length) {
          loadMoreBtn.style.display = 'none';
        } else {
          loadMoreBtn.style.display = 'inline-flex';

          // Remove existing listener to prevent duplicates
          const newBtn = loadMoreBtn.cloneNode(true);
          loadMoreBtn.parentNode.replaceChild(newBtn, loadMoreBtn);

          newBtn.addEventListener('click', function (e) {
            e.preventDefault();

            let shown = 0;
            for (let i = 0; i < items.length; i++) {
              if (items[i].style.display === 'none') {
                items[i].style.display = 'flex';
                shown++;
                visibleCount++;
                if (shown >= LOAD_MORE_COUNT) break;
              }
            }

            if (visibleCount >= items.length) {
              newBtn.style.display = 'none';
            }
          });
        }
      }
    }

    // Initialize both grids
    initGrid('board-grid');
    initGrid('executive-grid');

    // Re-initialize when tabs are switched (in case of display none quirks)
    const tabs = document.querySelectorAll('button[data-bs-toggle="tab"]');
    tabs.forEach(tab => {
      tab.addEventListener('shown.bs.tab', function (event) {
        const targetId = event.target.getAttribute('data-bs-target').replace('#', '');
        if (targetId === 'board-tab') initGrid('board-grid');
        if (targetId === 'executive-tab') initGrid('executive-grid');
      });
    });

  })();

  // =====================
  // Mega Menu / Dropdown mobile toggle (header.hbs)
  // =====================
  // (function initMegaMenuToggle() {
  //   const arrowWraps = document.querySelectorAll('.dropdown-arrow-icon-wrap');

  //   arrowWraps.forEach(function (arrowWrap) {
  //     arrowWrap.addEventListener('click', function (e) {
  //       if (window.innerWidth <= 767.98) {
  //         e.preventDefault();
  //         e.stopPropagation();

  //         const li = arrowWrap.closest('.dropdown-hover');
  //         if (li) {
  //           const megaMenu = li.querySelector('.mega-menu');
  //           if (megaMenu) {
  //             const isExpanded = megaMenu.classList.toggle('mobile-expanded');
  //             li.classList.toggle('mobile-expanded', isExpanded);
  //             arrowWrap.classList.toggle('expanded', isExpanded);

  //             const dropdownToggle = li.querySelector('.dropdown-toggle');
  //             if (dropdownToggle) {
  //               dropdownToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  //             }
  //           }
  //         }
  //       }
  //     });
  //   });
  // })();

  // =====================
  // Newsletter Form handling (footer.hbs)
  // =====================
  (function initNewsletterForm() {
    const formEl = document.getElementById("newsletterForm");
    const submitBtn = document.getElementById("newsletterSubmit");

    if (!formEl || !submitBtn) return;

    submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (formEl.requestSubmit) {
        formEl.requestSubmit();
      } else {
        formEl.dispatchEvent(new Event("submit", { cancelable: true }));
      }
    });

    formEl.addEventListener("submit", function (e) {
      e.preventDefault();
      const messageEl = document.getElementById("newsformMessage");
      if (!messageEl) return;

      messageEl.style.display = "none";
      messageEl.innerHTML = "";

      const emailInput = document.getElementById("newsemail");
      if (!emailInput) return;

      const email = emailInput.value.trim();

      if (!email) {
        showMessage("Please fill your email address.", "error");
        return;
      }

      const emailValid = email.indexOf("@") > -1 && email.indexOf(".") > -1;
      if (!emailValid) {
        showMessage("Please enter a valid email address.", "error");
        return;
      }

      showMessage("Thank you!", "success");
      formEl.reset();
      formEl.style.display = "none";

      function showMessage(msg, type) {
        messageEl.style.display = "block";
        messageEl.innerHTML = msg;
        messageEl.style.color = type === "success" ? "green" : "red";
      }
    });
  })();

  // =====================
  // 0c. Hero countdown timer
  // =====================
  (function initHeroCountdown() {
    var cdDays = document.getElementById('cd-days');
    if (!cdDays) return;

    var target = new Date("2026-08-22T00:00:00").getTime();

    function updateCountdown() {
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0) return;

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      cdDays.textContent = String(days).padStart(2, '0');
      document.getElementById('cd-hours').textContent = String(hours).padStart(2, '0');
      document.getElementById('cd-minutes').textContent = String(minutes).padStart(2, '0');
      document.getElementById('cd-seconds').textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  })();


  // =====================
  // Phone input plugins (contact-section.hbs)
  // =====================
  (function initPhoneInput() {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof window.intlTelInput === 'undefined') return;

      var phoneInputs = document.querySelectorAll('.phone-input input[type="tel"]');
      var utilsScript = "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.19/build/js/utils.js";

      phoneInputs.forEach(function (input) {
        var iti = window.intlTelInput(input, {
          separateDialCode: true,
          initialCountry: "sa",
          preferredCountries: ["ae", "sa", "eg", "qa"],
          utilsScript: utilsScript
        });

        // Attach instance to the DOM element for validation access
        input.iti = iti;

        // Update hidden country code input if this is the general phone form
        if (input.id === 'general-phone') {
          var countryCodeInput = document.getElementById('general-country-code');
          if (countryCodeInput) {
            // Set initial value
            var code = iti.getSelectedCountryData().dialCode;
            countryCodeInput.value = '+' + code;

            // Update on change
            input.addEventListener('countrychange', function () {
              var code = iti.getSelectedCountryData().dialCode;
              countryCodeInput.value = '+' + code;
            });
          }
        }
      });
    });
  })();

})();


